import type { Feed } from '../types';
import type { UpdateFeedRequest } from '../repositories/feedRepository';
import { FeedInformation } from './FeedInformation';

interface FeedCardProps {
  feed: Feed;
  isAdmin: boolean;
  onSave: (feedId: string, data: UpdateFeedRequest) => void;
  onDelete: (feedId: string) => void;
}

export function FeedCard({ feed, isAdmin, onSave, onDelete }: FeedCardProps) {
  return (
    <article className="site-card">
      <div className="site-card-header">
        <h3>{feed.title || feed.feed_url}</h3>
      </div>
      <FeedInformation
        info={feed}
        created_at={feed.created_at}
        updated_at={feed.updated_at}
        site_id={feed.site_id}
        isAdmin={isAdmin}
        onSave={(updated) => onSave(feed.id, updated)}
        onDelete={() => onDelete(feed.id)}
      />
    </article>
  );
}
